import { f as xr } from "./function-apply-4756dee6.js";
import { k as F, f as I, g as K, j as T, b as O, a0 as dr, e as $r, _ as Er, E as or, d as Sr, M as pr, r as sr, S as cr, t as br, C as ur, F as hr, l as Ir, h as yr, m as Tr } from "./export-cdcbfb2b.js";
import { t as G } from "./to-string-92a62764.js";
import { o as Or } from "./object-create-9b6715a2.js";
var Ar = F, _r = function() {
  var r = Ar(this), a = "";
  return r.hasIndices && (a += "d"), r.global && (a += "g"), r.ignoreCase && (a += "i"), r.multiline && (a += "m"), r.dotAll && (a += "s"), r.unicode && (a += "u"), r.unicodeSets && (a += "v"), r.sticky && (a += "y"), a;
}, Y = I, Rr = K, q = Rr.RegExp, H = Y(function() {
  var r = q("a", "y");
  return r.lastIndex = 2, r.exec("abcd") !== null;
}), Ur = H || Y(function() {
  return !q("a", "y").sticky;
}), Pr = H || Y(function() {
  var r = q("^r", "gy");
  return r.lastIndex = 2, r.exec("str") !== null;
}), Cr = {
  BROKEN_CARET: Pr,
  MISSED_STICKY: Ur,
  UNSUPPORTED_Y: H
}, Dr = I, Nr = K, mr = Nr.RegExp, Lr = Dr(function() {
  var r = mr(".", "s");
  return !(r.dotAll && r.test(`
`) && r.flags === "s");
}), wr = I, Mr = K, Br = Mr.RegExp, jr = wr(function() {
  var r = Br("(?<a>b)", "g");
  return r.exec("b").groups.a !== "b" || "b".replace(r, "$<a>c") !== "bc";
}), b = T, A = O, kr = G, Fr = _r, Kr = Cr, Gr = dr, Yr = Or, qr = $r.get, Hr = Lr, Wr = jr, Xr = Gr("native-string-replace", String.prototype.replace), y = RegExp.prototype.exec, M = y, zr = A("".charAt), Jr = A("".indexOf), Qr = A("".replace), D = A("".slice), B = function() {
  var r = /a/, a = /b*/g;
  return b(y, r, "a"), b(y, a, "a"), r.lastIndex !== 0 || a.lastIndex !== 0;
}(), fr = Kr.BROKEN_CARET, j = /()??/.exec("")[1] !== void 0, Zr = B || j || fr || Hr || Wr;
Zr && (M = function(a) {
  var n = this, s = qr(n), i = kr(a), v = s.raw, o, l, f, e, t, g, u;
  if (v)
    return v.lastIndex = n.lastIndex, o = b(M, v, i), n.lastIndex = v.lastIndex, o;
  var c = s.groups, $ = fr && n.sticky, x = b(Fr, n), d = n.source, S = 0, E = i;
  if ($ && (x = Qr(x, "y", ""), Jr(x, "g") === -1 && (x += "g"), E = D(i, n.lastIndex), n.lastIndex > 0 && (!n.multiline || n.multiline && zr(i, n.lastIndex - 1) !== `
`) && (d = "(?: " + d + ")", E = " " + E, S++), l = new RegExp("^(?:" + d + ")", x)), j && (l = new RegExp("^" + d + "$(?!\\s)", x)), B && (f = n.lastIndex), e = b(y, $ ? l : n, E), $ ? e ? (e.input = D(e.input, S), e[0] = D(e[0], S), e.index = n.lastIndex, n.lastIndex += e[0].length) : n.lastIndex = 0 : B && e && (n.lastIndex = n.global ? e.index + e[0].length : f), j && e && e.length > 1 && b(Xr, e[0], l, function() {
    for (t = 1; t < arguments.length - 2; t++)
      arguments[t] === void 0 && (e[t] = void 0);
  }), e && c)
    for (e.groups = g = Yr(null), t = 0; t < c.length; t++)
      u = c[t], g[u[0]] = e[u[1]];
  return e;
});
var W = M, Vr = Er, Q = W;
Vr({ target: "RegExp", proto: !0, forced: /./.exec !== Q }, {
  exec: Q
});
var Z = T, V = Sr, re = W, rr = I, gr = or, ee = pr, ae = gr("species"), N = RegExp.prototype, ne = function(r, a, n, s) {
  var i = gr(r), v = !rr(function() {
    var e = {};
    return e[i] = function() {
      return 7;
    }, ""[r](e) !== 7;
  }), o = v && !rr(function() {
    var e = !1, t = /a/;
    return r === "split" && (t = {}, t.constructor = {}, t.constructor[ae] = function() {
      return t;
    }, t.flags = "", t[i] = /./[i]), t.exec = function() {
      return e = !0, null;
    }, t[i](""), !e;
  });
  if (!v || !o || n) {
    var l = /./[i], f = a(i, ""[r], function(e, t, g, u, c) {
      var $ = t.exec;
      return $ === re || $ === N.exec ? v && !c ? { done: !0, value: Z(l, t, g, u) } : { done: !0, value: Z(e, g, t, u) } : { done: !1 };
    });
    V(String.prototype, r, f[0]), V(N, i, f[1]);
  }
  s && ee(N[i], "sham", !0);
}, X = O, te = cr, ie = G, ve = sr, le = X("".charAt), er = X("".charCodeAt), oe = X("".slice), ar = function(r) {
  return function(a, n) {
    var s = ie(ve(a)), i = te(n), v = s.length, o, l;
    return i < 0 || i >= v ? r ? "" : void 0 : (o = er(s, i), o < 55296 || o > 56319 || i + 1 === v || (l = er(s, i + 1)) < 56320 || l > 57343 ? r ? le(s, i) : o : r ? oe(s, i, i + 2) : (o - 55296 << 10) + (l - 56320) + 65536);
  };
}, se = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: ar(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: ar(!0)
}, ce = se.charAt, ue = function(r, a, n) {
  return a + (n ? ce(r, a).length : 1);
}, z = O, fe = br, ge = Math.floor, m = z("".charAt), xe = z("".replace), L = z("".slice), de = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, $e = /\$([$&'`]|\d{1,2})/g, Ee = function(r, a, n, s, i, v) {
  var o = n + r.length, l = s.length, f = $e;
  return i !== void 0 && (i = fe(i), f = de), xe(v, f, function(e, t) {
    var g;
    switch (m(t, 0)) {
      case "$":
        return "$";
      case "&":
        return r;
      case "`":
        return L(a, 0, n);
      case "'":
        return L(a, o);
      case "<":
        g = i[L(t, 1, -1)];
        break;
      default:
        var u = +t;
        if (u === 0)
          return e;
        if (u > l) {
          var c = ge(u / 10);
          return c === 0 ? e : c <= l ? s[c - 1] === void 0 ? m(t, 1) : s[c - 1] + m(t, 1) : e;
        }
        g = s[u - 1];
    }
    return g === void 0 ? "" : g;
  });
}, nr = T, Se = F, pe = ur, be = hr, he = W, Ie = TypeError, ye = function(r, a) {
  var n = r.exec;
  if (pe(n)) {
    var s = nr(n, r, a);
    return s !== null && Se(s), s;
  }
  if (be(r) === "RegExp")
    return nr(he, r, a);
  throw new Ie("RegExp#exec called on incompatible receiver");
}, Te = xr, tr = T, _ = O, Oe = ne, Ae = I, _e = F, Re = ur, Ue = Ir, Pe = cr, Ce = yr, p = G, De = sr, Ne = ue, me = Tr, Le = Ee, we = ye, Me = or, k = Me("replace"), Be = Math.max, je = Math.min, ke = _([].concat), w = _([].push), ir = _("".indexOf), vr = _("".slice), Fe = function(r) {
  return r === void 0 ? r : String(r);
}, Ke = function() {
  return "a".replace(/./, "$0") === "$0";
}(), lr = function() {
  return /./[k] ? /./[k]("a", "$0") === "" : !1;
}(), Ge = !Ae(function() {
  var r = /./;
  return r.exec = function() {
    var a = [];
    return a.groups = { a: "7" }, a;
  }, "".replace(r, "$<a>") !== "7";
});
Oe("replace", function(r, a, n) {
  var s = lr ? "$" : "$0";
  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function(v, o) {
      var l = De(this), f = Ue(v) ? void 0 : me(v, k);
      return f ? tr(f, v, l, o) : tr(a, p(l), v, o);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function(i, v) {
      var o = _e(this), l = p(i);
      if (typeof v == "string" && ir(v, s) === -1 && ir(v, "$<") === -1) {
        var f = n(a, o, l, v);
        if (f.done)
          return f.value;
      }
      var e = Re(v);
      e || (v = p(v));
      var t = o.global, g;
      t && (g = o.unicode, o.lastIndex = 0);
      for (var u = [], c; c = we(o, l), !(c === null || (w(u, c), !t)); ) {
        var $ = p(c[0]);
        $ === "" && (o.lastIndex = Ne(l, Ce(o.lastIndex), g));
      }
      for (var x = "", d = 0, S = 0; S < u.length; S++) {
        c = u[S];
        for (var E = p(c[0]), h = Be(je(Pe(c.index), l.length), 0), R = [], U, P = 1; P < c.length; P++)
          w(R, Fe(c[P]));
        var C = c.groups;
        if (e) {
          var J = ke([E], R, h, l);
          C !== void 0 && w(J, C), U = p(Te(v, void 0, J));
        } else
          U = Le(E, l, h, R, C, v);
        h >= d && (x += vr(l, d, h) + U, d = h + E.length);
      }
      return x + vr(l, d);
    }
  ];
}, !Ge || !Ke || lr);
export {
  ue as a,
  _r as b,
  Lr as c,
  jr as d,
  Cr as e,
  ne as f,
  Ee as g,
  ye as r,
  se as s
};
